import type { ReactNode } from 'react';
import { Stack, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { DataObject } from '@/api/objects';

const ORIGINS = ['uploaded', 'referenced', 'derived'] as const;

/** One table per origin (uploaded, linked, generated), each under its own subheading; empty origins are left out. */
export function ObjectsByOrigin({ objects, children }: { objects: DataObject[]; children: (objects: DataObject[]) => ReactNode }) {
  const { t } = useTranslation('projects');
  return (
    <Stack gap="md">
      {ORIGINS.map((origin) => {
        const group = objects.filter((o) => o.origin === origin);
        if (group.length === 0) return null;
        return (
          <Stack key={origin} gap="xs">
            <Title order={4}>{t(`objects.origin.${origin}`)}</Title>
            {children(group)}
          </Stack>
        );
      })}
    </Stack>
  );
}
